import ModuleLanding from '../ecosystem/components/ModuleLanding';

const verifyHero = 'https://readdy.ai/api/search-image?query=Professional%20certificate%20verification%20concept%2C%20digital%20badge%20and%20QR%20code%20verification%20system%2C%20trusted%20credentials%20platform%2C%20warm%20green%20and%20golden%20accents%2C%20clean%20minimal%20dark%20background%2C%20professional%20editorial%20photography&width=1600&height=800&seq=verify-hero-01&orientation=landscape';

const features = [
  { icon: 'ri-shield-check-line', title: 'Vérification Instantanée', description: 'Vérifiez n\'importe quel certificat en entrant son ID unique ou en scannant le QR code. Résultat immédiat.' },
  { icon: 'ri-qr-code-line', title: 'QR Code Sécurisé', description: 'Chaque certificat génère automatiquement un QR code unique contenant un lien de vérification sécurisé.' },
  { icon: 'ri-passport-line', title: 'Types de Vérification', description: 'Certificats de cours, certifications professionnelles, badges, accomplissements, identités freelances et vendeurs.' },
  { icon: 'ri-error-warning-line', title: 'Statuts Multiples', description: 'Valid, Expired, Revoked, Suspended, Invalid. Suivi complet du statut avec dates d\'émission et d\'expiration.' },
  { icon: 'ri-fingerprint-line', title: 'Signature Numérique', description: 'Chaque certificat porte une signature numérique sécurisée empêchant toute falsification ou duplication.' },
  { icon: 'ri-global-line', title: 'Portail Public', description: 'Vérifiez sans compte. ID du certificat, nom, QR code ou email suffisent pour confirmer l\'authenticité.' },
  { icon: 'ri-building-line', title: 'Vérification Employeur', description: 'Les employeurs vérifient instantanément les diplômes et certifications des candidats avec rapport téléchargeable.' },
  { icon: 'ri-bar-chart-grouped-line', title: 'Analytics & Rapports', description: 'Tableaux de bord avec volumes de vérification, détection de fraude, statistiques et rapports d\'audit complets.' },
  { icon: 'ri-links-line', title: 'Intégration Automatique', description: 'Connexion automatique avec Learn, Work, Shop et Jobs. Chaque certificat émis est immédiatement vérifiable.' },
];

const related = [
  { name: 'Learn', path: '/learn', icon: 'ri-graduation-cap-line' },
  { name: 'Work', path: '/work', icon: 'ri-briefcase-4-line' },
  { name: 'Business', path: '/', icon: 'ri-building-2-line' },
  { name: 'Jobs', path: '/jobs', icon: 'ri-id-card-line' },
];

function VerifyPage() {
  return (
    <ModuleLanding
      name="Verify"
      tagline="Authentifiez. Confiez. Validez."
      description="WorldApeiron Verify est l'autorité de vérification officielle de l'écosystème. Vérifiez instantanément les certificats, diplômes, badges et identités numériques avec un QR code scannable. La confiance, en un clic."
      heroImageUrl={verifyHero}
      features={features}
      ctaText="Vérifier un certificat"
      secondaryCta={{ text: 'En savoir plus' }}
      accentColor="accent"
      relatedModules={related}
    />
  );
}

export default VerifyPage;